import { useGetPyqPaperList } from "../hooks/useGetPyqPaperList";
import { isEmpty } from "../../../../../../../custom_utilities/custom_useful_functions";
import "./YearWiseData.scss";
import usePyqRedux from "../hooks/usePyqRedux";
import useAuthUtils from "../../../../../../../hooks/auth/useAuthUtils";
import { useMemo } from "react";
import useAppHooks from "../../../../../../../shared/hooks/useAppHooks";
import { setTestDetails } from "../../../../../../../redux/exam/examSlice";
import { useHistory } from "react-router-dom"; // Import useHistory

const YearWiseData = () => {
  const { dispatch } = useAppHooks();
  const history = useHistory(); // Use useHistory for navigation

  const { data } = useGetPyqPaperList();
  const { pyqMainCurrentTab, setPyqTestsResultData, setPyqTestsData } =
    usePyqRedux();
  const { targetId } = useAuthUtils();

  const filterdData = useMemo(() => {
    if (targetId == "2") {
      if (pyqMainCurrentTab?.type === "main") {
        return data?.filter((elem) =>
          elem?.format?.toLowerCase().includes("main")
        );
      }

      if (pyqMainCurrentTab?.type === "adv") {
        return data?.filter((elem) =>
          elem?.format?.toLowerCase().includes("adv")
        );
      }
    }
    return data;
  }, [data, targetId, pyqMainCurrentTab]);

  const onHandleTakeTest = (testData) => {
    if (!testData.is_attempt) {
      if (testData.paper_type.toLowerCase() === "paid") {
        alert("You have to purchase a plan from store");
        history.push("/store");
      } else {
        setPyqTestsData(testData);
        dispatch(setTestDetails(testData));
        // navigateTo("/PYQ_Test");
         history.push("/test-instruction");
        // navigateTo("/PYQ_Test");
        //  history.push("/test-instruction");
      }
    }
  };

  const onHandleTakeTest2 = (testData) => {
    if (!testData.is_attempt) {
      if (testData.paper_type.toLowerCase() === "paid") {
        alert("You have to purchase a plan from store");
        history.push("/store");
      } else {
        setPyqTestsData(testData);
        history.push("/PYQ_Practice_Test");
      }
    }
  };

  const onHandleSummary = (testData) => {
    setPyqTestsResultData(testData);
    history.push("/pyq-summary");
  };

  // Handle Locked button click (Navigate to Package page)
  const onHandleLocked = (packageId) => {
    history.push(`/package/${packageId}`);
  };

  return (
    <div className="upcomingExamWrapper">
      {!isEmpty(filterdData) && filterdData.length
        ? filterdData.map((element, index) => {
            const isLocked = element.is_subscribed === 0;

            return (
              <div key={index} className="upcomingExamBox">
                <div className="pyqNameType">
                  <div className="pyqName">
                    <span>{element.paper_name}</span>
                  </div>
                </div>

                <div className="attemBtn">
                  {isLocked ? (
                    // If locked, show only one "Locked" button
                    <button
                      className="locked"
                      onClick={() => onHandleLocked(element.package_id)} // Navigate to package page
                    >
                      Locked
                    </button>
                  ) : (
                    <>
                      {/* Take Test Button */}
                      <button
                        className="attempt"
                        onClick={() => onHandleTakeTest(element)}
                      >
                        Take Test
                      </button>

                      {/* Practice Button */}
                      <button
                        className="practice"
                        onClick={() => onHandleTakeTest2(element)}
                      >
                        Practice
                      </button>

                      {element.is_attempted === 1 && (
                        <button
                          className="practice"
                          onClick={() => onHandleSummary(element)}
                        >
                          Summary
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            );
          })
        : null}
    </div>
  );
};

export default YearWiseData;
